import { Tooltip } from 'antd';
import React, { Fragment, useEffect, useState } from 'react';
import styles from "./filelistcenter.module.scss";
import iconmusic from "../../../../styles/images/grid_music.svg";
import iconpdf from "../../../../styles/images/grid_pdf.svg";
import iconppt from "../../../../styles/images/grid_ppt.svg";
import iconword from "../../../../styles/images/grid_word.svg";
import iconxls from "../../../../styles/images/grid_xls.svg";
import iconzip from "../../../../styles/images/grid_zip.svg";
import iconviewarrow from "../../../../styles/images/viewarrow.svg";
import iconotsupport from "../../../../styles/images/hiddenimage.svg";
import { excelFormats, pptFormats, wordFormats, zipFormats,
  mp3Formats, pdfFormats, imageFormat, getFileSize, videoFormat } from '../../../../base/utils';
import moment from 'moment';
import { contactwindowDetails, initialStateModel, LoginState } from '../../../../models/model';
import { HighlightInner } from '../../rightsidebar/highlight';
import _ from 'lodash';
import Lottie from 'lottie-react';
import NoContent from '../../../../shared/widgets/noContent';
import FileNoFound from "../../../../styles/images/empty_states/files_empty_state.svg";
import groovyWalkAnimation from "../../../../styles/images/chat blank state loading.json";
import ContactLoader from "../../../../styles/images/Lottie Animation.json";
import { useSelector } from 'react-redux';
type ListViewProps={
  fileslist:any;
  onclickgetId:Function;
  openShare:Function;
  openDelete:Function;
  downloadfiles:Function;
  viewinConversation:Function;
  onclickallfilegetId:Function;
  isSearch:boolean;
  searchWord:string;
}
type listviewState={
  fileslist:any;
}
export default function ListView({fileslist,isSearch,
  onclickgetId,openShare,openDelete,downloadfiles,onclickallfilegetId,
  viewinConversation,searchWord}:ListViewProps) {
  let { contactFileList, isContactFile }: contactwindowDetails =
    useSelector((state: initialStateModel) => state.contactWindowReducer);
    const {userdetails}: LoginState = useSelector((state: initialStateModel) => state.loginReducer);

  const [listViewFiles, setlistViewFiles] = useState<listviewState>({fileslist:contactFileList});

  const openFileimage=(file:any,messageBody?:any)=>{
    if(imageFormat.includes(messageBody?.fileType) ){
      onclickgetId(file);
    }else{
      onclickallfilegetId(file);
    }
  };
  useEffect(() => {
    if(isSearch){
      setlistViewFiles({fileslist:fileslist});
    }else{
      setlistViewFiles({fileslist:contactFileList});
    }
    return () => {
      setlistViewFiles({fileslist:fileslist});
    };
  }, [fileslist,contactFileList]);
  const openshare=(file:any)=>{
    openShare(file);
  };
  const opendelete=(file:any)=>{
    openDelete(file);
  };
  const downloadAlfiles =(file:any)=>{
    downloadfiles(file);
  };
  const viewInConversation =(file:any)=>{
    viewinConversation(file);
  };


  let filterArray = _.filter(listViewFiles.fileslist,((datas:any)=>{
    let messageBody = datas?.message?.body;
    console.log("messageBody>>",messageBody);
    return imageFormat.indexOf(messageBody?.fileType) !== -1 ||
    pdfFormats.indexOf(messageBody?.fileType) !== -1 ||
    wordFormats.indexOf(messageBody?.fileType) !== -1 ||
    pptFormats.indexOf(messageBody?.fileType) !== -1 ||
      excelFormats.indexOf(messageBody?.fileType) !== -1 ||
      videoFormat.indexOf(messageBody?.fileType) !== -1 ||
      mp3Formats.indexOf(messageBody?.fileType) !== -1 
    }));
  return (
    <div>
      {isContactFile &&  fileslist.length === 0 && filterArray.length===0&&  <NoContent image={FileNoFound}
          title={"Worktual files"}
          description={<>No files .</>} />}
         { !isContactFile && fileslist.length === 0 &&
        <Lottie className="svgLoading"
        animationData={ContactLoader} />}
      {filterArray?.map((file: any, i: number)=>{
         let messageBody = file?.message.body;
         let filePath = messageBody?.filePath;
         let fileType =messageBody?.fileType;
        let fileSize =messageBody?.filesize;
        let fileName =messageBody?.fileName?.length > 40 ? messageBody?.fileName.substring(0, 39) + "..." : messageBody?.fileName;
        let isCloudfiles = messageBody?.isCloudfiles || false;
        return (
        <Fragment key={i}>
          <div className={styles.filelistview}>
        
            <div className={styles.fileleft} onClick={()=> { isCloudfiles ?  window.open(filePath): openFileimage(file,messageBody)}}>
              <div className={styles.listleftimage}>
                {imageFormat.indexOf(fileType)  !== -1  ?
                  <img className={styles.filelistimage} src={isCloudfiles ? iconotsupport:filePath}
                     alt="" />:
                  excelFormats.indexOf(fileType) !== -1  ?
                    <img className={styles.filelistimage} src={iconxls} alt=""/>:
                  pptFormats.indexOf(fileType) !== -1  ?
                     <img className={styles.filelistimage} src={iconppt} alt=""/>:
                  wordFormats.indexOf(fileType)  !== -1 ?
                    <img className={styles.filelistimage} src={iconword} alt=""/>:
                  mp3Formats.indexOf(fileType)  !== -1 ?
                    <img className={styles.filelistimage} src={iconmusic} alt=""/> :
                  videoFormat.indexOf(fileType) !== -1 ? 
                     <div className="videoFiles">
                      <video className="videoFluid" controls={true} preload="metadata">
                        <source src={file?.filePath} type="video/mp4" />
                      </video>
                      <div className="videoPlay"></div>
                    </div> :
                    zipFormats.indexOf(fileType)  !== -1  ?
                      <img className={styles.filelistimage} src={iconzip} alt=""/>:
                      pdfFormats.indexOf(fileType) !== -1 &&
                        <img className={styles.filelistimage} src={iconpdf} alt=""
                          onClick={()=>openFileimage(file,messageBody)}/>
          }
              </div>
              <div className={styles.listrighttext}>

                <p> <HighlightInner content={fileName}
                  searchedData={searchWord}></HighlightInner></p>
                <h3>              
                  <span>{getFileSize(fileSize)}  </span>
                  <span> {moment(new Date(parseInt(file.timestamp))).format(" ddd, MMM DD, YYYY")}</span>
                </h3>
              </div>
            { isCloudfiles && <div className={styles.viewarrowlink}> 
              <img src={iconviewarrow} alt=''/>
            </div>}
            </div>
           
            <div className={styles.hoverOptions}>
              <ul className={styles.hoverList}>
                <Tooltip mouseEnterDelay={0.5} title='Download' className='cusTooltip' overlayClassName='customTooltip'>
                  <li><span className="icon_Downloadstroke"
                    onClick={()=>downloadAlfiles(file)}></span></li></Tooltip>
                <Tooltip mouseEnterDelay={0.5} title='Share' className='cusTooltip' overlayClassName='customTooltip'>
                  <li><span className="icon_reply" onClick={()=>openshare(file)} ></span></li></Tooltip>
                <Tooltip mouseEnterDelay={0.5}  title='Conversation' className='cusTooltip' overlayClassName='customTooltip'>
                  <li><span className="icon_chat" onClick={()=>viewInConversation(file)}></span></li></Tooltip>
                   {(window.location.pathname.includes('contact') && userdetails?.sip_login_id.toString() === file?.from?.toString() ? 
                      <Tooltip  mouseEnterDelay={0.5} title='Delete' className='cusTooltip' overlayClassName='customTooltip'>
                      <li><span className="icon_delete" onClick={()=>opendelete(file)}></span></li></Tooltip> :

                  window.location.pathname.includes('chat') && userdetails?.sip_login_id.toString() === file?.from?.toString()  &&
                    <Tooltip  mouseEnterDelay={0.5} title='Delete' className='cusTooltip' overlayClassName='customTooltip'>
                        <li><span className="icon_delete" onClick={() => opendelete(file)}></span></li></Tooltip> 
                  )} 
              </ul>
            </div>
          </div>
         
        </Fragment>
      )})}
      
    </div>

   
  );
}


